import React from 'react';
import { connect } from 'react-redux';
import { selectHeaderState } from '../../store/slice';
import { RootState } from 'src/app/store';

import { AccountName, IA2AccountDropdownButton } from './styles';

interface EmptyAccountDropdownProps {
  currentAccountName?: string;
}

const EmptyAccountDropdown: React.VFC<EmptyAccountDropdownProps> = ({
  currentAccountName,
}) => {
  return (
    <>
      <IA2AccountDropdownButton data-ccx-e2e-id="aac-account-dropdown">
        <AccountName>{currentAccountName}</AccountName>
      </IA2AccountDropdownButton>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentAccountName:
      selectHeaderState(state).currentAccountInfo?.currentAccountName,
  };
};

export default connect(mapStateToProps)(EmptyAccountDropdown);
